import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/jobs-new")({
  beforeLoad: () => {
    throw redirect({
      to: "/calendar",
      replace: true,
    })
  },
})
